import { render, staticRenderFns } from "./EditDetailsDialog.vue?vue&type=template&id=079f83e0&scoped=true&"
import script from "./EditDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditDetailsDialog.vue?vue&type=style&index=0&id=079f83e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f83e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VForm,VIcon})
